import { MDBCol, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import { Link } from 'react-router-dom'

export default function Addresses() {
  return (
    <div className='mar-left mt-4'>
      <MDBRow>

        {/* New York */}
        <MDBCol lg='4' md='6' xs='12' className='p-2 text-center'>
       
            <h3 className='mb-4'><b>New York</b></h3>
          <div className='d-flex align-items-start'>
            <Link to='https://maps.app.goo.gl/ZMTrufqQ4n9WpBzs6'>
              <div className='py-3 px-4 text-black'>
              <span>
                <i className="fa-solid fa-location-dot font-size"></i>
                </span>
              </div>
            </Link>
            <div className='pt-2 px-3 text-start'>
              <p><b>Address:</b></p>
              <p className='m-0'>
                SkyLab Diamond Inc.<br />
                580 5th Avenue, Suite 1002,<br />
                New York, NY 10036
              </p>
            </div>
          </div>

        </MDBCol>

        {/* Los Angeles */}
        <MDBCol lg='4' md='6' xs='12' className='p-2 text-center  position-relative '>
            <h3 className='mb-4'><b>Los Angeles</b></h3>
          <div className='d-flex align-items-start'>
            <Link to='https://maps.app.goo.gl/LosAngelesAddressLink' target="_blank" rel="noreferrer">
              <div className='py-3 px-4 text-black'>
                <i className="fa-solid fa-location-dot font-size"></i>
              </div>
            </Link>
            <div className='pt-2 px-3 text-start'>
              <p><b>Address:</b></p>
              <p className='m-0'>
              SkyLab Diamond Inc.<br />
               550 South Hill Street,
                Suite 1250,<br />
                Los Angeles, CA 90013
              </p>
            </div>
          </div>

        </MDBCol>

        {/* Toronto */}
        <MDBCol lg='4' md='12' xs='12' className='p-2 text-center'>
          <h3 className='mb-4'><b>Canada</b></h3>
          <div className='d-flex align-items-start'>
            <Link
              to='https://www.google.com/maps/search/?api=1&query=55%20Queen%20Street%20East%2C%20Unit%20803%2C%20Toronto%20ON%20M5C%201R6%2C%20Canada'
              target="_blank"
              rel="noreferrer"
            >
              <div className='py-3 px-4 text-black'>
                <i className="fa-solid fa-location-dot font-size"></i>
              </div>
            </Link>
            <div className='pt-2 px-3 text-start'>
              <p><b>Address:</b></p>
              <p className='m-0'>
                SkyLab Diamond Inc.<br />
                55 Queen Street East, Unit 803,<br />
                Toronto ON, M5C 1R6 Canada
              </p>
            </div>
          </div>
        </MDBCol>
        <MDBCol lg='12' md='12' xs='12' className='pt-4'>
          <div
            style={{
              borderTop: "1px solid #000",
              paddingTop: "18px",
              paddingBottom: "50px",
            }}
          >
            <MDBRow className='align-items-start'>
              <MDBCol md='6' xs='12' className='p-2'>
  {/* Email */}
  <div className='d-flex align-items-start justify-content-start'>
    <a href="mailto:info@skylabdiamond.com">
      <div className='py-3 px-4 text-black'>
        <span id='zoom-loop-animation'>
          <i className="fa-solid fa-envelope font-size"></i>
        </span>
      </div>
    </a>
    <div className='pt-2 px-2 text-start'>
      <p className='m-0'><b>Email:</b><br />info@skylabdiamond.com</p>
    </div>
  </div>

  {/* Phone — now rendered below Email (red marked area) */}
  <div className='d-flex align-items-start justify-content-start'>
    <a href="tel:+16468924262">
      <div className='py-3 px-4 text-black'>
        <i className="fa-solid fa-phone font-size"></i>
      </div>
    </a>
    <div className='pt-3 px-2 text-start'>
      <p className='m-0'><b>Phone:</b> +1 (646) 892 4262</p>
    </div>
  </div>
</MDBCol>

{/* Remove the old Phone MDBCol entirely */}

              <MDBCol lg='5' md='12' xs='12' className='p-2 text-start'>
                <p className="m-0">
                  <b>Business Hours:</b>
                </p>
                <p className="m-0">
                  Monday to Friday - 9:30am to 6:00pm
                  <br />
                  Saturday to Sunday - Closed
                </p>
              </MDBCol>
            </MDBRow>
          </div>
        </MDBCol>
        
          {/* <MDBCol lg='12' md='3' xs='3' className='p-3'>
                <div className='text-center'>
                    <Link to='https://skylabdiamond.com/'><MDBBtn className='py-3 px-4 rounded-circle bg-black text-light' color='black'>
                        <span id='zoom-loop-animation'><MDBIcon fas icon="external-link-alt" /></span>
                    </MDBBtn></Link>
                    <p className='pt-2'><b>Website : </b>https://skylabdiamond.com/</p>
                </div>
            </MDBCol> */}

      </MDBRow>
    </div>
  )
}
